type CmsErrorDetails = Record<string, any>;

export class CmsError extends Error {
    public readonly details: CmsErrorDetails = {};

    constructor(message: string, details: CmsErrorDetails) {
        super(message);

        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, CmsError.prototype);

        this.name = 'CMSError';

        if (Object.keys(details || {}).length) {
            this.details = details;
        }
    }
}
